import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { InputSwitch } from 'primereact/inputswitch'
import { Label } from 'reactstrap'

const CustomSwitch = ({ onChange, checked, label, name, disabled }) => {
  return (
    <Fragment>
      {label && <Label className='d-block'>{label}</Label>}
      <InputSwitch checked={checked} onChange={onChange} name={name} disabled={disabled} />
    </Fragment>
  )
}

CustomSwitch.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
}

export default CustomSwitch
